module.exports = __webpack_public_path__ + "static/media/CharterDay_20170908_4866.f084b42a.jpg";